<template>
  <div class="wrap">
    <el-form :inline="true">
      <el-form-item>
        <el-date-picker
          v-model="allAttribute.time"
          type="date"
          :picker-options="{
            disabledDate,
          }"
          value-format="yyyy-MM-dd"
          placeholder="选择期望发货日期"
        />
      </el-form-item>

      <el-form-item>
        <el-select v-model="allAttribute.freight" placeholder="请选择货运属性">
          <el-option
            v-for="(value, key) in freightProperty"
            :key="key"
            :label="value"
            :value="key"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="batchSettings">
          批量设置
        </el-button>
        <el-button type="default" @click="setMaterialNum()">
          设置料号
        </el-button>
        <el-button type="default" @click="addNewRow">
          添加产品行
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table
      ref="productTable"
      v-loading="isLoading"
      :data="productList"
      border
      show-summary
      :summary-method="getSummaries"
      class="productTable"
    >
      <el-table-column type="index" width="70" label="序号" align="left">
        <template v-slot="{ row, $index }">
          {{ (row.itemIndex = $index + 1) }}
        </template>
      </el-table-column>

      <el-table-column
        prop="productCode"
        label="销售代码"
        align="left"
        min-width="140"
      />

      <el-table-column
        prop="productName"
        label="产品型号"
        align="left"
        min-width="150"
      >
        <template v-slot="{ row }">
          <chooseProduct ref="chooseProduct" :row="row" :form="form" />
        </template>
      </el-table-column>

      <el-table-column
        prop="productCode"
        label="料号"
        align="left"
        min-width="120"
      >
        <template v-slot="{ row, $index }">
          <el-button
            type="text"
            :disabled="
              row.exclusiveMaterialNumber != '' &&
                row.exclusiveMaterialNumber != null
            "
            @click="setSingleMaterialNum(row, $index)"
          >
            {{ row.materialNumberId ? row.materialNumberId : "选择料号" }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column prop="productNum" label="数量" align="left" width="90">
        <template v-slot="{ row, $index }">
          <el-input-number
            v-model="row.productNum"
            :min="1"
            :controls="false"
            style="width: 100%"
            @blur="changeSetMoney(row, $index)"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="productPriceSigle"
        label="单价"
        align="right"
        header-align="left"
        min-width="135"
      >
        <template v-slot="{ row, $index }">
          <el-input-number
            v-model="row.productPriceSigle"
            :min="0"
            :controls="false"
            style="width: 100%"
            @blur="changeSetMoney(row, $index)"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="orderAmount"
        label="订单金额"
        align="right"
        header-align="left"
        min-width="135"
      />

      <el-table-column
        prop="settlementAmount"
        label="实际结算金额"
        align="right"
        header-align="left"
        min-width="135"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.settlementAmount"
            :min="0"
            :precision="2"
            :controls="false"
            style="width: 100%"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="isBorrow"
        label="测试借条转订单"
        align="left"
        min-width="110"
      >
        <template v-slot="{ row }">
          <el-checkbox v-model="row.isBorrow" />
        </template>
      </el-table-column>

      <el-table-column
        prop="expectedDeliveryDate"
        label="期望发货日期"
        align="left"
        min-width="155"
      >
        <template v-slot="{ row }">
          <el-date-picker
            v-model="row.expectedDeliveryDate"
            type="date"
            style="width: 100%"
            value-format="yyyy-MM-dd"
            placeholder="期望发货日期"
            :clearable="false"
            :picker-options="{
              disabledDate,
            }"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="beforeSplitProductPriceSigle"
        label="拆分前单价"
        align="right"
        header-align="left"
        min-width="100"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.beforeSplitProductPriceSigle"
            :min="0"
            :controls="false"
            style="width: 100%"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="freightProperty"
        label="货运属性"
        align="left"
        min-width="150"
      >
        <template v-slot="{ row }">
          <el-select v-model="row.freightProperty" placeholder="货运属性">
            <el-option
              v-for="(value, key) in freightProperty"
              :key="key"
              :label="value"
              :value="key"
            />
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="税率" align="right" header-align="left" width="130">
        <template v-slot="{ row }">
          <el-select v-model="row.rate" placeholder="请选择税率">
            <el-option
              v-for="item in taxRateList"
              :key="item.dictLabel"
              :label="item.dictValue"
              :value="item.dictLabel"
            />
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="left" fixed="right" width="100">
        <template v-slot="{ row, $index }">
          <el-button
            type="text"
            style="padding: 0"
            @click="copyRow(row, $index)"
          >
            <i class="el-icon-circle-plus-outline" style="font-size: 16px" />
          </el-button>

          <el-button
            type="text"
            style="padding: 0; color: #f56c6c"
            @click="removeProduct($index)"
          >
            <i class="el-icon-delete" style="font-size: 16px" />
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 料号 -->
    <material-num ref="MaterialNum" @chooseMateria="chooseMateria" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import chooseProduct from '@/views/contractCommonInput/chooseProduct.vue';
import MaterialNum from '@/views/contractCommonInput/MaterialNum.vue';
import { DateToStr, getNum } from '@/libs/util';
import Big from 'big.js';
import { calculateProductSettlementAmount } from '@/API/index.js';
import { getDictData } from '@/API/international';
import dayjs from 'dayjs';

export default {
  components: {
    chooseProduct,
    MaterialNum
  },

  props: {
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    contractType: {
      type: String,
      default: ''
    },
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    form: {
      type: Object,
      default: () => {}
    },
    contractId: {
      type: [String, Number],
      default: ''
    }
  },

  data () {
    return {
      allAttribute: {
        time: '',
        freight: ''
      },
      isLoading: false,
      productList: [],
      summariesData: {
        productNum: 0,
        orderAmount: 0,
        settlementAmount: 0,
        beforeSplitProductPriceSigle: 0
      },
      taxRateList: []
    };
  },

  computed: {
    ...mapState({
      freightProperty: (state) => state.enumeration.freightProperty
    })
  },
  watch: {
    contractType (newValue) {
      if (newValue === 'SMB分销下单') {
        this.productList.forEach((item) => {
          item.expectedDeliveryDate = dayjs().format('YYYY-MM-DD');
        });
      }
    }
  },
  created () {
    this.addNewRow();
    this.taxRateFn();
  },

  methods: {
    dayjs,
    // 获取税率
    taxRateFn () {
      let params = { dictType: 'tax_rate' };
      getDictData(params).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.taxRateList = data;
        }
      });
    },

    // 批量设置
    batchSettings () {
      let error = '';
      this.productList.forEach((item) => {
        if (this.allAttribute.time) {
          let nowDateStr = DateToStr(new Date());
          if (new Date(this.allAttribute.time) >= new Date(nowDateStr)) {
            this.$set(item, 'expectedDeliveryDate', this.allAttribute.time);
          } else {
            error = '期望发货日期不能小于当前日期';
          }
        }

        if (this.allAttribute.freight) {
          this.$set(item, 'freightProperty', this.allAttribute.freight);
        }
      });

      if (error) {
        this.$notify.error({ message: error });
      }
    },

    // 添加行
    addNewRow () {
      this.productList.push({
        orderAmount: 0,
        settlementAmount: 0,
        materialNumberId: '',
        productNum: 0,
        productPriceSigle: 0,
        beforeSplitProductPriceSigle: 0,
        isBorrow: false,
        expectedDeliveryDate: ''
      });
    },

    // 复制行
    copyRow (row, index) {
      this.productList.splice(index + 1, 0, {
        ...this.$cloneDeep(row),
        id: null
      });
    },

    // 删除行
    removeProduct (index) {
      this.$confirm('是否删除该产品?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.productList.splice(index, 1);
        })
        .catch(() => {});
    },

    // 设置料号
    setMaterialNum (row, index) {
      if (!this.contractType) {
        this.$notify.error({ message: '请先选择订单分类' });
        return false;
      }

      if (!this.productList.some((data) => data.productCode)) {
        this.$notify.error({ message: '请选择产品型号' });
        return false;
      }

      let productAndMaterialGroup = [];
      let MaterialNumValues = {};

      this.productList.forEach((item) => {
        if (item.productCode) {
          productAndMaterialGroup.push({
            productSalesCode: item.productCode,
            productName: item.productName,
            exclusiveMaterial: item.materialNumberId || '',
            productNum: item.productNum,
            isHavePowerCord: item.isHavePowerCord || false,
            isTestOrder: item.isBorrow || false
          });
          MaterialNumValues[item.productCode] = {
            materialNumberId: item.materialNumberId,
            materialUnit: item.materialUnit
          };
        }
      });

      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName || '',
        materialReqProductVOS: productAndMaterialGroup
      };

      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },

    // 设置单个料号
    setSingleMaterialNum (row, index) {
      if (!this.contractType) {
        this.$notify.error({ message: '请先选择订单分类' });
        return false;
      }
      if (!row.productCode) {
        this.$notify.error({ message: '请选择产品型号' });
        return false;
      }

      let productAndMaterialGroup = [];
      let MaterialNumValues = {};

      if (row.productCode) {
        productAndMaterialGroup.push({
          productSalesCode: row.productCode,
          productName: row.productName,
          exclusiveMaterial: row.materialNumberId,
          productNum: row.productNum,
          isHavePowerCord: row.isHavePowerCord || false,
          isTestOrder: row.isBorrow || false
        });
        MaterialNumValues[row.productCode] = {
          materialNumberId: row.materialNumberId,
          materialUnit: row.materialUnit
        };
      }

      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName || '',
        materialReqProductVOS: productAndMaterialGroup
      };

      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },

    // 选择料号回调
    chooseMateria ({ list, RowIndex }) {
      // 设置表单值
      let setTableProps = (RowIndex, data) => {
        this.productList[RowIndex].materialNumberId = data.selected;
        this.productList[RowIndex].materialUnit = data.materialUnit;
        this.productList[RowIndex].softFlag = data.softFlag;
      };

      // 判断是否是设置单个料号
      if (RowIndex === 'all') {
        list.forEach((data, index) => {
          let row = this.productList[index];
          if (row.productCode === data.productSalesCode) {
            setTableProps(index, data);
          }
        });
      } else {
        setTableProps(RowIndex, list[0]);
      }
    },

    // 数量、单价，变更调用接口计算获取：订单金额和实际结算金额
    changeSetMoney (row, index) {
      let params = {
        // 返点：创建合同为0
        rebate: 0,
        // 返利金额：创建合同为0
        rebateAmount: 0,
        // 通讯折扣: 创建合同为0
        communicationOrderDiscount: 0,
        // 1 现销 2 赊销
        salesType: this.salesType,
        productList: this.productList.map((item) => ({
          id: item.id,
          productCode: item.productCode,
          productCategoryName: item.productCategoryName,
          productPriceSingle: item.productPriceSigle,
          productNum: item.productNum
        }))
      };
      this.isLoading = true;

      calculateProductSettlementAmount(params)
        .then((res) => {
          let { status, data } = res.data;
          if (status === '200') {
            let result = data[index];
            row.orderAmount = result.orderAmount;
            row.settlementAmount = result.settlementAmount;
          }
        })
        .catch(() => {
          row.productNum = 0;
          row.productPriceSigle = 0;
          row.orderAmount = 0;
          row.settlementAmount = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    // 计算合计
    getSummaries ({ columns, data }) {
      let sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = data.reduce(
            (pre, cur) =>
              getNum(Big(getNum(cur.productNum)).plus(pre).toString()),
            0
          );
          this.summariesData.productNum = sums[index];
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = data.reduce(
            (pre, cur) =>
              getNum(Big(getNum(cur.orderAmount)).plus(pre).toString()),
            0
          );
          this.summariesData.orderAmount = sums[index];
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = data.reduce(
            (pre, cur) =>
              getNum(Big(getNum(cur.settlementAmount)).plus(pre).toString()),
            0
          );
          this.summariesData.settlementAmount = sums[index];
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = data.reduce((pre, cur) => {
            return getNum(
              Big(getNum(cur.productNum))
                .times(getNum(cur.beforeSplitProductPriceSigle))
                .plus(pre)
                .toString()
            );
          }, 0);
          this.summariesData.beforeSplitProductPriceSigle = sums[index];
        }
      });
      return sums;
    },

    // 暴露出去的数据
    getSubmitData () {
      return {
        productList: this.productList,
        summariesData: this.summariesData
      };
    },
    disabledDate (time) {
      if (this.contractType === 'SMB分销下单') {
        if (dayjs(time).format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD')) {
          return false;
        }
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 20px;
}
</style>
